<ng-container *ngIf="!loadingFormDetails; loading">
    <div class="form">
        <h2 mat-dialog-title>{{ currentCultureFormName }}</h2>
        
        <mat-dialog-content>
            <div class="page-description-section" *ngIf="!hideWorkingHours && workingHours !== null">
                This time off request is for {{workingHours}} working hours
            </div>

            <app-form-generator 
                [formId]="formId"
                [formData]="formData"
                [emitFormDataTrigger]="getFormData"
                [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
                (emitFormData)="formDataEmitted($event)"
                (emitFormDataChange)="formDataChanged($event)"
                (emitFormPristine)="formPristineEmitted($event)"
                (emitFormStatus)="formStatusUpdated($event)"
            ></app-form-generator>
        </mat-dialog-content>
        
        <mat-dialog-actions>
            <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
            
            <button 
                *appTableAccess="[tableUpdateAccessObj]" 
                mat-raised-button 
                setColor="primaryColour" 
                color="primary" 
                [disabled]="formValid === false" 
                appPreventDoubleClick 
                (throttledClick)="getFormData = !getFormData">
                {{ 'Save' | translate: {Default: "Save"} }}
            </button> 
        </mat-dialog-actions>
    </div>
</ng-container>

<ng-template #loading>
    <mat-dialog-content class="loading">
        <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
        ></ngx-skeleton-loader>
    </mat-dialog-content>
</ng-template>